import React, { useState, useEffect } from "react";
import store from "../reduxstore";
import { LoginModal } from "../components/navigationbar/accountmenu";

function hasChildRoleOf(basicRole) {
  //例如'实验空间学生'是'学生'的一种，得到true
  const { account } = store.getState();
  const { role } = account;
  return role.indexOf(basicRole) !== -1;
}

function hasExactRole(exactRole) {
  //例如'实验空间学生'不是精确的'学生'，得到false
  const { account } = store.getState();
  const { role } = account;
  return role === exactRole;
}

//拥有子角色
function hasRole(roles) {
  const { account } = store.getState();
  const { role } = account;
  let checkResult = false;
  roles.forEach(allowedRole => {
    if (hasChildRoleOf(allowedRole)) {
      checkResult = true;
    }
  });
  // console.log(checkResult);
  return checkResult;
  // return !(roles.indexOf(role) === -1);
}

//拥有精确的角色
function hasExactRoleOf(roles) {
  const { account } = store.getState();
  const { role } = account;

  return !(roles.indexOf(role) === -1);
}

//实验空间学生无法创建条文
// const authWrapper = rolesAllowed => ComposedComponent => props => {
//   if (hasExactRoleOf(rolesAllowed)) {
//     return <ComposedComponent {...props} />;
//   } else {
//     return null;
//   }
// };

const authWrapper = rolesAllowed => ComposedComponent => props => {
  if (hasRole(rolesAllowed)) {
    return <ComposedComponent {...props} />;
  } else {
    return null;
  }
};

const LoginModalPage = props => {
  let { uri } = props;
  const [open, setOpen] = useState(true);
  const handleClose = () => {
    setOpen(false);
  };
  //当uri改变时需要重新加载将modal打开，否则从无权限页面跳转到无权限页面时不会触发登录框
  useEffect(() => {
    setOpen(true);
  }, [uri]);
  return (
    <LoginModal
      open={open}
      handleClose={handleClose}
      formTitle="请登陆后访问此页面"
    />
  );
};

export {
  hasRole,
  hasChildRoleOf,
  hasExactRole,
  hasExactRoleOf,
  authWrapper,
  LoginModalPage
};
